import { Component } from "react";
import { Link } from "react-router-dom";
class ProductMainCard extends Component {
  state = {
    day: 0,
    time: 0,
  };
  handleCountDown = (seconds) => {
    var secs = seconds;
    const countDown = setInterval(() => {
      const HourMinuteSecond = new Date(secs * 1000)
        .toISOString()
        .substr(11, 8);
      const day = (secs / 86400).toString().split(".")[0];
      if (secs > 0) {
        secs--;
        this.setState({ time: HourMinuteSecond, day: day });
      } else {
        clearInterval(countDown);
      }
    }, 1000);
  };
  componentDidMount() {
    if (this.props.countDown) {
      this.handleCountDown(this.props.deadline);
    }
  }

  render() {
    const propertyIcons = {
      // season
      56: "icon-weather",
      // country
      31: "icon-global",
      // weightResistance
      32: "icon-weight",
      // speedResistance
      33: "icon-speed",
    };
    const {
      id,
      features,
      image,
      brand,
      price_percent,
      min_price,
      old_price,
      name,
      stock,
    } = this.props.data || {};
    return (
      <Link to={`/product/${id}`} className="goldenSaleCard">
        {features?.length > 0 ? (
          <div className="properties">
            {features && features.length > 0 ? (
              <div className="features">
                {features.map((item, index) => (
                  <div className="property" key={index}>
                    <i className={propertyIcons[item.id]} />
                    <span>{item.value}</span>
                  </div>
                ))}
              </div>
            ) : null}
          </div>
        ) : null}
        <img
          src={image}
          onError={(e) => (e.currentTarget.src = "../assets/icons/car.svg")}
          alt="tire"
        />
        <div className="info">
          <span className="productName">{name}</span>
          <div className="priceInfo">
            {/* {price_percent > 0 && (
                <div className="mainPrice">
                  <span className="primary">{old_price.toLocaleString()}</span>
                  <span className="percent">%{price_percent}</span>
                </div>
              )} */}
            {stock === 0 ? (
              <span className="outOfStock">ناموجود</span>
            ) : (
              <>
                <div className="price">
                  <span>{price_percent}%</span>
                  <span>{min_price.toLocaleString()} تومان</span>
                </div>
                <span className="oldPrice">{old_price}</span>
              </>
            )}
          </div>
        </div>
      </Link>
    );
  }
}

export default ProductMainCard;
